<template>
  <div id="app">
    <Toast></Toast>
    <Loading></Loading>
    <router-view />
  </div>
</template>

<script>
import replaceHttpsImg from './lib/repalceHttpsImg'
import Vue from 'vue'
import { Cookie } from "./lib/utils";
export default {
  name: "App",
  created() {
    console.log('APP')
    this.initLoginInfo()
    this.event()
  },
  methods: {
    event() {
      window.addEventListener('message', e => {//父获取子传递的消息
          if(e.data.type == 'hash') {
            this.$router.push(`/${e.data.data}`)
          }
      }, false)
    },
    initLoginInfo() {
      //调试
      //Cookie.write('KuGoo',"KugooID=1764249045&KugooPwd=54E8917556F5F5EE69497B574A67BDD4&NickName=%u0044%u004a%u004d%u0049%u0058&Pic=http://imge.kugou.com/kugouicon/165/20201023/20201023100246605342.jpg&RegState=1&RegFrom=&t=0d4ef7fa53290d0aeb4864b67c9ae5724f000f57acacddacbbc61898ceb86fc1&a_id=1014&ct=1621836666&UserName=%u0031%u0037%u0036%u0034%u0032%u0034%u0039%u0030%u0034%u0035")
      const globalParam = {};
      globalParam.mid = Cookie.read("kg_mid");
      window.mid = globalParam.mid || ''
      console.log('Cookie.read("kg_mid")',Cookie.read("kg_mid"))
      if (Cookie.read("KuGoo")) {
        //已登录
        globalParam.NickName = unescape(Cookie.read("KuGoo", "NickName"));
        globalParam.UserName = unescape(Cookie.read("KuGoo", "UserName"));
        globalParam.KugooID = Cookie.read("KuGoo", "KugooID");
        globalParam.appid = Cookie.read("KuGoo", "a_id");
        globalParam.token = Cookie.read("KuGoo", "t");
        globalParam.Pic = unescape(Cookie.read("KuGoo", "Pic"));
        if (!globalParam.Pic || globalParam.Pic == "default.jpg" || globalParam.Pic == "") {
          globalParam.Pic = "https://imgessl.kugou.com/kugouicon/165/20120724/20120724145917274529.jpg";
        } else if (globalParam.Pic.indexOf("http://") != -1) {
          globalParam.Pic = replaceHttpsImg(globalParam.Pic)
        } else {
          globalParam.Pic = `https://imgessl.kugou.com/kugouicon/165/${globalParam.Pic.substr(0, 8)}/${globalParam.Pic}`;
        }
        globalParam.isLogin = true;

        //登录信息挂载在全局
        Vue.prototype.globalParam = globalParam
        console.log('Vue.prototype.globalParam', this.globalParam)

      } else {
        //未登录
        try {
          Cookie.remove("KuGoo", "/", "kugou.com");
          setCookie('KuGoo','',-1)
        } catch (error) {}
        if(window.self == window.top){
          window.location.href = 'https://musician.kugou.com';
        }else{
          window.top.location.href = 'https://musician.kugou.com';
        }
      }
    },
  },
};
</script>

<style lang="scss">
@import "./assets/css/common.scss";
@import "./assets/css/icon.css";
@import "./assets/css/webuploader.scss";
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  min-width: 1000px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue